<template>
    <div id="SetUserStatus">
        <el-dialog :center="true" title="设置状态" :visible.sync="dialogVisible" width="500px">
            <div class="content">
                <h4>用户状态</h4>
                <el-radio-group v-model="params.status">
                    <el-radio class="eb-radio" label="0" @change="selectedCurrent">首次注册</el-radio>
                    <el-radio class="eb-radio" label="1" @change="selectedCurrent">正常登录</el-radio>
                    <el-radio class="eb-radio" label="2" @change="selectedCurrent">禁止登录</el-radio>
                </el-radio-group>
            </div>
            <div class="eb-button-group">
                <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="dialogVisible = false">取消</el-button>
                <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="confirmBtn">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import eventBus from '@/plugins/event-bus';
import { setUser } from '@/services/user/user-service';
export default {
  name: 'SetUserStatus',
  data() {
    return {
      dialogVisible: false,
      params: {
        userId: '',
        status: ''
      },
      selectedStatus: ''
    };
  },
  created() {
    eventBus.$on('setUserStatus', (userId, status) => {
      this.params.userId = userId;
      this.params.status = status;
      this.dialogVisible = true;
    });
  },
  methods: {
    selectedCurrent: function(label) {
      this.selectedStatus = label;
    },
    confirmBtn: function() {
      if (this.userId === parseInt(this.$store.state.user.userInfo.userid) && this.selectedStatus === '2') {
        this.$message.error('管理员不能设定自己为“禁止登录');
        return false;
      }
      this.setUserStatus();
    },
    async setUserStatus() {
      try {
        let { data } = await setUser(this.params);
        if (data.returnCode === '01') {
          this.$message.success('设置用户状态成功');
          this.dialogVisible = false;
          eventBus.$emit('addOrEditDeptsuccess');
        } else {
          this.$message.error('设置用户状态失败');
        }
      } catch (error) {
        this.$message.error('请检查服务器连接！');
      }
    }
  },
  beforeDestroy() {
    eventBus.$off('setUserStatus');
  }
};
</script>
<style lang="less" scoped>
#SetUserStatus {
  .content {
    padding-left: 60px;
    h4 {
      font-size: 18px;
    }
  }
}
</style>
